import TiktokEmbedPost from '@cohort/components-xps/components/apps/tiktok/TiktokEmbedPost';
import type {TikTokRepostTiktokTriggerStruct} from '@cohort/shared/apps/tiktok/triggers/repostTiktok';
import serializeDataAttributes from '@cohort/shared-frontend/utils/serializeDataAtttributes';
import type {DetailsComponentProps} from '@cohort/wallet/apps/TriggerIntegration';

const TiktokRepostTiktokTriggerIntegrationDetailsComponent: React.FC<
  DetailsComponentProps<TikTokRepostTiktokTriggerStruct>
> = ({config, stepId, triggerId}) => (
  <div
    className="flex w-full items-center justify-center"
    {...serializeDataAttributes({
      'step-id': stepId,
      'trigger-id': triggerId,
    })}
  >
    <TiktokEmbedPost videoId={config.videoId} />
  </div>
);

export default TiktokRepostTiktokTriggerIntegrationDetailsComponent;
